import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { IDynamicComponent, IDynamicComponentConfig } from './interfaces';

@Directive()
export abstract class DynamicComponentBase implements IDynamicComponent, OnInit, ControlValueAccessor {
  _config: IDynamicComponentConfig;
  @Input() set config(val: IDynamicComponentConfig) {
    this._config = val;
    if (val) {
      this.configChange(val);
    }
  }

  get config() {
    return this._config;
  }

  ready: boolean;

  @Output() readyChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  get data() {
    return this.config;
  }

  constructor() {
    this.initConfig();
  }

  ngOnInit(): void {
    this.imReady();
  }

  registerOnChange(fn: any): void {
    this.valueChange.emit = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {
    this.config.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this.config.value = obj;
  }

  imReady() {
    this.ready = true;
    this.readyChange.emit(true);
  }

  onChange(val: any) {
    this.valueChange.emit(val);
    if (typeof this.config.onChange === 'function') {
      this.config.onChange(this.config.name, val);
    }
  }

  /** 初始化配置 */
  initConfig() {}

  /** 配置发生改变 */
  abstract configChange(config: IDynamicComponentConfig);
}
